export const getTypeContratPayment = (
  typeContrat: string,
  typeContratPayment: string = '',
) => {
  if (typeContrat === 'retraite') {
    return 'retraite';
  } else if (typeContrat === 'rcvp' || typeContratPayment === 'rcvp') {
    return 'rcvp';
  } else if (typeContrat === 'scolaire' || typeContratPayment === 'scolaire') {
    return 'scolaire';
  } else if (typeContrat === 'voyage') {
    return 'voyage';
  } else if (typeContrat === 'auto') {
    return 'auto';
  } else if (typeContrat === 'rattache' || typeContratPayment === 'rattache') {
    return 'rattache';
  } else if (typeContrat === 'rattache' || typeContratPayment === 'rattache') {
    return 'rattache';
  } else if (
    typeContrat === 'rapatriement' ||
    typeContratPayment === 'rapatriement'
  ) {
    return 'rapatriement';
  } else {
    return 'autre';
  }
};
